import { render } from "./basic_defined_strategic_management.vue?vue&type=template&id=13ce45ad&scoped=true"
import script from "./basic_defined_strategic_management.vue?vue&type=script&lang=js"
export * from "./basic_defined_strategic_management.vue?vue&type=script&lang=js"

import "./basic_defined_strategic_management.vue?vue&type=style&index=0&id=13ce45ad&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ce45ad"]])

export default __exports__